import { toWords } from 'number-to-words';

const getAmountInWords = (amount) => {
  const baht = Math.floor(amount);
  const satang = Math.round((amount - baht) * 100);

  let inWords = toWords(baht).replace(/^\w/, c => c.toUpperCase()); // capitalize first letter
  let final = `${inWords} Baht`;

  if (satang > 0) {
    final += ` and ${toWords(satang)} Satang`;
  }

  return final + ' Only';
};
export default getAmountInWords;